import { SHOULD_SHOW_MESSAGE } from '../actions/updateShouldShowMessageAction';

const updatePromos = (state = {}, action) => {
    const { type = null, datasource, data } = action;

    if (type === 'dataEngine_update_response' && datasource === 'gumbo') {
        const { gameData, liveData } = data || {};
        const status = gameData?.status?.abstractGameState;
        const inningState = liveData?.linescore?.inningState;
        const currentInning = liveData?.linescore?.currentInning;
        const hasGameSwitched = state.gamePk !== gameData.game?.pk;
        const isLoading = hasGameSwitched;

        const newData = {
            ...state,
            inningState,
            currentInning,
            gameStatus: status,
            gamePk: gameData.game?.pk,
            isLoading,
            shouldShowMessage: hasGameSwitched ? true : state?.shouldShowMessage
        };

        return newData;
    } else if (type === 'dataEngine_update_response' && datasource === 'productConfig') {
        const {
            promos
        } = data;

        return {
            ...state,
            promos
        };
    } else if (type === SHOULD_SHOW_MESSAGE) {
        return {
            ...state,
            shouldShowMessage: action.shouldShowMessage
        };
    }

    return state;
};

export default updatePromos;
